// extracted by mini-css-extract-plugin
export default {"form":"SearchInput_form__rgfWQ","input":"SearchInput_input__oXb+b","btn":"SearchInput_btn__Ltfon"};